import { StyleSheet, Text } from "react-native";

import {
  spacing,
  type,
  useThemedStyles,
  type ThemeColors,
} from "~/styles/theme";

export function PageTitle({
  title,
  subtitle,
}: {
  title: string;
  subtitle?: string;
}) {
  const stylesheet = useThemedStyles(makeStyles);
  return (
    <>
      <Text style={stylesheet.title}>{title}</Text>
      {subtitle ? <Text style={stylesheet.subtitle}>{subtitle}</Text> : null}
    </>
  );
}

const makeStyles = (colors: ThemeColors) =>
  StyleSheet.create({
    title: {
      ...type.display,
      color: colors.heading,
    },
    subtitle: {
      ...type.body,
      marginTop: spacing.xs,
      color: colors.mutedForeground,
    },
  });
